import React from 'react';
import { Link } from 'react-router-dom';
import { Leaf, Zap, Gauge, BarChart3 } from 'lucide-react';
import SEO from '../components/SEO';

const PILLARS = [
  { icon: Zap, title: 'Solo consumes la IA que necesitas', text: 'Sin suscripciones infrautilizadas, sin energía desperdiciada. Cada crédito corresponde a trabajo real ejecutado.' },
  { icon: Gauge, title: 'Modelos eficientes por tarea', text: 'Nuestro router activa solo lo necesario para cada tarea: modelos ligeros para lo simple, modelos potentes solo cuando aportan valor. Menos energía, facturación justa.' },
  { icon: BarChart3, title: 'Contador de consumo eficiente', text: 'En tu panel ves tu consumo real frente a lo que pagarías con tarifas planas equivalentes: transparencia económica y ecológica.' },
];

export default function SostenibilidadPage() {
  return (
    <main className="min-h-screen bg-background pt-32 pb-24">
      <SEO
        title="Sostenibilidad — Neuralia369"
        description="Facturación por consumo real como modelo ecológico: solo consumes la IA que necesitas. Sin suscripciones infrautilizadas, sin energía desperdiciada."
        path="/sostenibilidad"
      />
      <div className="mx-auto max-w-5xl px-6">
        <p className="editorial-kicker mb-4 flex items-center gap-2"><Leaf className="h-4 w-4 text-emerald-400" /> Sostenibilidad</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl text-text-heading" data-testid="sostenibilidad-title">La facturación justa también es ecológica</h1>
        <p className="mt-6 max-w-3xl text-lg text-text-body">Solo consumes la IA que necesitas. Sin suscripciones infrautilizadas, sin energía desperdiciada. Nuestro modelo de consumo real medido es, además de más barato, más responsable.</p>
        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {PILLARS.map(({ icon: Icon, title, text }) => (
            <div key={title} className="glass-card p-6" data-testid={`sostenibilidad-pillar-${title.slice(0, 10)}`}>
              <Icon className="h-6 w-6 text-emerald-400" />
              <h2 className="mt-4 text-lg font-semibold text-text-heading">{title}</h2>
              <p className="mt-2 text-sm text-text-body">{text}</p>
            </div>
          ))}
        </div>
        <div className="mt-12 rounded-[24px] border border-emerald-400/25 bg-emerald-400/5 p-8" data-testid="sostenibilidad-cta">
          <h2 className="text-lg font-bold text-text-heading">Un solo saldo. Todas las IA. Consumo real.</h2>
          <p className="mt-2 max-w-2xl text-sm text-text-body">Deja de pagar 10 suscripciones que no usas al completo. Con Neuralia369 cada crédito se convierte en trabajo hecho.</p>
          <Link to="/precios" className="btn-primary mt-5 inline-flex" data-testid="sostenibilidad-pricing-cta">Ver precios y calculadora</Link>
        </div>
      </div>
    </main>
  );
}
